import React from 'react';

function MenuHeading({ title }) {
  return (
    <h2 className="mt-5 text-2xl font-bold text-accent mb-10">{title}</h2>
  );
}

export default MenuHeading;
